import { create } from 'zustand';
import { organizationService } from '@/services/superAdmin/organizationService';
import { superAdminSchoolService } from '@/services/superAdmin/schoolService';

export const useSuperAdminDashboardStore = create((set) => ({
  stats: null,
  loading: false,
  error: null,

  fetchDashboardStats: async () => {
    set({ loading: true, error: null });
    try {
      const [orgsRes, schoolsRes] = await Promise.all([
        organizationService.getOrganizations(),
        superAdminSchoolService.getAllSchools(),
      ]);

      const orgs = orgsRes.data.items || [];
      const schools = schoolsRes.data.items || [];

      const totalOrgs = orgs.length;
      const activeOrgs = orgs.filter(o => o.status === 'active' || o.status === 'ACTIVE').length;
      
      const totalSchools = schools.length;
      const activeSchools = schools.filter(s => s.status === 'active' || s.status === 'ACTIVE').length;

      set({
        stats: {
          totalOrganizations: totalOrgs,
          activeOrganizations: activeOrgs,
          inactiveOrganizations: totalOrgs - activeOrgs,
          totalSchools,
          activeSchools,
          inactiveSchools: totalSchools - activeSchools,
          recentOrganizations: orgs.slice(-5).reverse(),
          recentSchools: schools.slice(-5).reverse(),
        },
        loading: false
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  }
}));
